"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sum = void 0;
const functions_1 = require("../functions");
const Helpers_1 = require("../functions/Helpers");
const C = require("../util/Consts");
const BaseAggregator_1 = require("./BaseAggregator");
class Sum extends BaseAggregator_1.BaseAggregator {
    constructor() {
        super(...arguments);
        this.summer = functions_1.regularFunctions[C.RegularOperator.ADDITION];
    }
    static emptyValue() {
        return (0, Helpers_1.integer)(0).toRDF();
    }
    init(start) {
        return this.termToNumericOrError(start);
    }
    put(state, term) {
        const internalTerm = this.termToNumericOrError(term);
        const sum = this.summer.apply([state, internalTerm], this.sharedContext);
        return sum;
    }
    result(state) {
        return state.toRDF();
    }
}
exports.Sum = Sum;
//# sourceMappingURL=Sum.js.map